import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { t } from '@lingui/core/macro';
import { getAllChildDevicesByType, isDuo } from 'util/device';
import api, { parseErrors } from 'util/api';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import { last } from 'lodash';


function ReassignDeviceModal({device, close, dismiss}) {
  const [processing, setProcessing] = useState();
  const [error, setError] = useState();
  const [selectedParent, setSelectedParent] = useState('');
  const currentParent = last(device.path);
  const availableParents = getAllChildDevicesByType(device.path[0], currentParent.type)
    .filter(d => {
      return !isDuo(d.externalId) && ![31, 44].includes(d.deviceModel) && // Ignore Duo sub-devices
      d.deviceModel == currentParent.deviceModel; // Make sure we only show parents of the same model as the current parent
    });

  function handleSubmit() {
    setProcessing(true);
    setError(null);
    api(`/devices/${selectedParent}/${device.model.id}/${(device.model.type || '').toLowerCase()}/assign`, {
      method: 'POST',
      body: JSON.stringify({
        parentId: selectedParent,
        unassignedNodeId: device.model.id,
        type: device.model.type
      })
    })
    .then(res => {
      close(selectedParent);
    })
    .catch(async err => {
      try {
        const errorMsg = await err.json();
        setError(parseErrors(errorMsg));
      } catch (e) {
        setError(t`An unknown error occurred.`);
      }
    })
    .finally(() => {
      setProcessing(false);
    });
  }

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>Select a new parent for</Trans>: <strong>{device.model.name}</strong></h3>
      </header>
      <section>
        <Banner status="alert" show={!!error && !processing}>
          {error}
        </Banner>
        <ul className="form">
          <li>
            <select
              id="parent-select"
              aria-label={i18n._(t`Select a new parent device`)}
              value={selectedParent}
              onChange={e => setSelectedParent(e.target.value)}
            >
              <option value="" disabled><Trans>Select parent...</Trans></option>
              {availableParents.map(p => {
                if (p.id == currentParent.id) return null;
                return (
                  <option value={p.id} key={`parent-device-option-${p.id}`}>
                    {p.name}
                  </option>
                );
              })}
            </select>
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary ${processing ? 'processing' : ''}`}
          disabled={processing || !selectedParent || selectedParent == currentParent.id}
          onClick={handleSubmit}
        >
          <Trans>Reassign</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default ReassignDeviceModal;
